import { DataGrid } from '@mui/x-data-grid/DataGrid';
import { styled } from '@mui/material/styles';

const StyledDataGrid = styled(DataGrid)(({ theme }) => ({
    '& .MuiDataGrid-columnHeader': {
      backgroundColor: 'background.header',
      padding: '0 1rem',
    },
    '& .MuiDataGrid-cell': {
      borderRight: 'none',
      alignContent: 'center',
      py: 1,
    },
    '& .MuiDataGrid-columnSeparator': {
      display: 'none',
    },
    '& .MuiDataGrid-row': {
      borderBottom: '1px solid theme.palette.divider',
    },
    border: 'none',
    '& .MuiDataGrid-footerContainer': {
      padding: '0.5rem',
    },
    '& .MuiDataGrid-row.Mui-selected': {
      backgroundColor: 'transparent !important',
    },
    '& .MuiDataGrid-row.Mui-selected:hover': {
      backgroundColor: 'rgba(0,0,0,0.04) !important',
    },
    '& .MuiDataGrid-cell:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-cell:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus': {
      outline: 'none',
    },
    '& .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
}));

export default StyledDataGrid